import { useCopies } from "shared/hooks/useCopies";
import MyExpApi from "apps/myExperience/enum/MyExpApi";
import { successToast } from "shared/utils/toastNotification";
import ParticipantSubRole from "shared/enums/ParticipantSubRole";
import { ApiRegistrationFormForRegResponse } from "shared/types/ApiRegistrationFormForRegResponse";
import { ApiRegistrationParticipantForParticipantResponse } from "shared/types/ApiRegistrationParticipantForParticipantResponse";
import { ApiRegistrationParticipantForManagement } from "shared/types/ApiRegistrationParticipantForManagement";
import { useGetApiData, usePostApiData } from "shared/datalayer";

export function useGetOrgAdminCreateForm({
  registrationId,
  errorHandler
}: {
  registrationId?: string;
  errorHandler: () => void;
}) {
  return useGetApiData<ApiRegistrationFormForRegResponse>(
    MyExpApi.FIND_NON_ATTENDEE_REGISTRATION_FORM,
    {
      params: { registrationId, participantSubRole: ParticipantSubRole.ORGANIZATION_ADMIN }
    },
    {
      enabled: Boolean(registrationId),
      onError: () => {
        errorHandler();
      }
    }
  );
}

export function useGetFormByRegistrationParticipant({
  registrationParticipantId,
  registrationFormId
}: {
  registrationParticipantId?: string;
  registrationFormId?: string;
}) {
  return useGetApiData<ApiRegistrationParticipantForParticipantResponse>(
    MyExpApi.FIND_REGISTRATION_FORM_BY_REG_PARTICIPANT_ID,
    {
      params: { registrationParticipantId, registrationFormId }
    },
    {
      enabled: Boolean(registrationParticipantId) && Boolean(registrationFormId)
    }
  );
}

export function useCreateOrgAdmin() {
  const copies = useCopies();
  return usePostApiData<ApiRegistrationParticipantForParticipantResponse>(MyExpApi.INITIATE_NON_ATTENDEE_REGISTRATION, {
    onSuccess: () => {
      successToast(copies.get("org.admin.create.another.org.admin.success"));
    }
  });
}

export function useNominateOrgAdmin() {
  const copies = useCopies();
  return usePostApiData<ApiRegistrationParticipantForManagement>(MyExpApi.NOMINATE_ORG_ADMIN, {
    onSuccess: () => {
      successToast(copies.get("org.admin.nominate.another.org.admin.success"));
    }
  });
}
